import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppHeaderTitleComponent } from './app-header-title.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { QuotationQuotationsResourceModule } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.module';
import { AppHeaderTitleService } from './app-header-title.service';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        LoaderModule,
        QuotationQuotationsResourceModule,
        NotificationModule,
        FontAwesomeModule,
    ],
    exports: [
        AppHeaderTitleComponent,
    ],
    declarations: [AppHeaderTitleComponent],
    providers: [
        AppHeaderTitleService,
    ],
})
export class AppHeaderTitleModule { }
